<!--
  Icone du jeu « Zelio Impact » — DS-1.18.

  Emploi :

      <zi-icon name="IconNotes" />              (16 px, decorative)
      <zi-icon name="IconBulb" :size="20" />
      <zi-icon name="IconAlert" :label="$t('lca.excludedPhases')" />

  Rend `<svg class="zi-icon"><use href="#IconNotes"/></svg>`, c'est-a-dire le
  mecanisme du prototype. Les symboles vivent dans `ziIconSprite.vue`, monte une
  seule fois dans `App.vue` : ce composant ne porte aucun trace, il ne fait que
  pointer un symbole.

  POURQUOI UN COMPOSANT ET PAS LE MARKUP A LA MAIN
  `DESIGN_SYSTEM.md` §8 decrit precisement cette signature
  (`<Icon name="IconDownload" size={16} />`), et le prototype emploie QUATRE
  tailles selon le contexte — 14 dans un libelle de champ, 16 dans un titre de
  carte, 20 pour un encart ou un bouton d'icone, 24 pour une fleche de flux.
  Un composant tient cette echelle en un endroit ; le markup repete, non.

  COULEUR
  Tous les symboles sont traces en `currentColor` : l'icone herite de la couleur
  du texte PAR CONSTRUCTION, dans tous les etats, sans qu'on ait a la redire
  etat par etat comme l'exigeait FontAwesome. Ne jamais poser de `color` ici :
  c'est le parent qui decide, et c'est ce qui garantit la regle de `CLAUDE.md`
  (« icone et texte TOUJOURS de la meme couleur »).

  ACCESSIBILITE
  Sans `label`, l'icone est decorative : `aria-hidden="true"` et pas de role —
  c'est le cas a cote d'un libelle, ou le texte dit deja tout. Avec `label`,
  elle porte l'information : `role="img"` et `aria-label`. `DESIGN_SYSTEM.md`
  §8 : « Une icone qui porte l'information recoit un texte alternatif en
  francais ; a cote d'un libelle, elle est `aria-hidden`. »
-->
<template>
  <svg
    class="zi-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    :role="label ? 'img' : null"
    :aria-label="label || null"
    :aria-hidden="label ? null : 'true'"
    focusable="false"
  >
    <use :href="`#${name}`" />
  </svg>
</template>

<script>
export default {
  name: 'ziIcon',
  props: {
    /**
     * Identifiant du symbole, tel qu'il est declare dans `ziIconSprite.vue` —
     * « IconNotes », « IconAlert »… Les noms viennent du prototype et ne sont
     * pas traduits : ce sont des identifiants, pas du contenu.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Cote en pixels. Echelle du design system : 12 (tags), 16 (champs,
     * listes, boutons), 24 (defaut du DS), 32 (etats vides) — plus 14 et 20,
     * employes par le prototype pour le declencheur d'infobulle dans un
     * libelle et pour l'icone d'un encart.
     *
     * 16 par defaut parce que c'est la taille de loin la plus frequente dans
     * les ecrans ACV du prototype.
     */
    size: {
      type: [Number, String],
      default: 16
    },
    /**
     * Texte alternatif, en francais. A ne renseigner QUE si l'icone porte une
     * information que le texte voisin ne donne pas : sinon le lecteur d'ecran
     * annonce deux fois la meme chose.
     */
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
